import { Platform } from 'react-native';
import { CasesContent } from "@/components/cases/CasesContent";

export default function Cases() {
  // Add platform-specific styling container if needed
  return Platform.OS === 'web' ? (
    <CasesContent />
  ) : (
    <CasesContent />
  );
}